import { render, staticRenderFns } from "./NavbarTopCategory.vue?vue&type=template&id=2539fb75"
import script from "./NavbarTopCategory.vue?vue&type=script&lang=js"
export * from "./NavbarTopCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports